import { Component, OnInit } from '@angular/core';
import { E5coreUiWorkFieldTypeCheckboxBaseComponent } from './e5core-ui-work-field-type-checkbox-base';

@Component({
  selector: 'e5core-ui-work-field-type-checkbox-box',
  templateUrl: './e5core-ui-work-field-type-checkbox-box.component.html',
  styleUrls: ['./e5core-ui-work-field-type-checkbox-box.component.css']
})
export class E5coreUiWorkFieldTypeCheckboxBoxComponent extends E5coreUiWorkFieldTypeCheckboxBaseComponent {
}

